import RelatedPosts from "./related-posts.component";

export default RelatedPosts;
